export default __webpack_public_path__ + "static/instructorjob-3c51b2f6f1f3416461422c6632da4a86.jpg";